"use client";

export {
  Arrow,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpAndRight,
} from "./deprecated/Arrow";
